import type { AwaitingEvidenceItem } from "../models/awaitingEvidence";
import {
  getEvidenceStatusLabel,
  isAwaitingReviewStatus,
  normalizeEvidenceStatus,
} from "../models/evidenceItem";
import {
  getEvidenceDocumentPath,
  getEvidenceTypeLabel,
} from "./evidenceDocumentType";

export type AwaitingEvidenceRow = {
  id: string;
  typeLabel: string;
  fileName: string | null;
  statusLabel: string;
  /** Sekretariatet er længere om det end AI'en, så det fremhæves. */
  isAwaitingSecretariat: boolean;
  documentPath: string | null;
};

export const toAwaitingEvidenceRow = (
  item: AwaitingEvidenceItem,
): AwaitingEvidenceRow => {
  const status = normalizeEvidenceStatus(item.status);

  return {
    id: item.id,
    typeLabel: getEvidenceTypeLabel(item.evidenceType),
    fileName: item.fileName?.trim() ? item.fileName : null,
    statusLabel: getEvidenceStatusLabel(item.status),
    isAwaitingSecretariat: status ? isAwaitingReviewStatus(status) : false,
    documentPath: getEvidenceDocumentPath(item.evidenceType, item.id),
  };
};
